import './CommsHubBuyerSelectionModal.scss';
import React, { useEffect, useState } from 'react';
import { Timeline } from '../../../../../../../slices/marketplace/timeline/models/timeline.model';
import { BuyerCommunicationChat } from '../MarketplaceBuyerCommunicationsTab';
import { Button, Col, Row } from 'reactstrap';
import Rodal from '../../../../../../../components/Rodal/Rodal';
import BuyerProfilePreviewPopup from '../../../../../../../components/BuyerProfilePreviewPopup/BuyerProfilePreviewPopup';
import { NotificationFlag } from '../../../../../../../components/NotificationFlag/NotificationFlag';
import { NotificationFlagsCategories } from '../../../../../../../models/NotificationFlags/NotificationFlagsCategories';

export interface CommsHubBuyerSelectionModalProps {
    onClose: () => void;
    isVisible: boolean;
    engagement: Timeline;
    selectedChat: BuyerCommunicationChat;
    availableChats: BuyerCommunicationChat[];
    onChatSelect: (chat: BuyerCommunicationChat) => void;
}

export const CommsHubBuyerSelectionModal = (
    props: CommsHubBuyerSelectionModalProps
) => {
    const [selectedBuyerProfile, setSelectedBuyerProfile] = useState<number>();
    return (
        <div>
            <Rodal
                visible={props.isVisible}
                animation="slideTop"
                onClose={() => props.onClose()}
                showMask={false}
                width={600}
                closeOnEsc
                className="modal-comms-hub-buyer-selection"
                center>
                <div className="modal-header">Select Buyer Chat</div>
                <div className="modal-body">
                    {props.availableChats.length > 0 ? (
                        <div>
                            {props.availableChats.map((chat) => (
                                <Row
                                    key={chat.id}
                                    className="align-items-center mb-2">
                                    <Col
                                        xs="8"
                                        className="text-truncate"
                                        style={{ maxWidth: 300 }}>
                                        <span
                                            className="clickable-text"
                                            onClick={() =>
                                                setSelectedBuyerProfile(chat.id)
                                            }>
                                            {chat.name}
                                            <NotificationFlag
                                                eventCode={`${NotificationFlagsCategories.MpCode}.${props.engagement?.id}.${NotificationFlagsCategories.CommsHubCode}.${NotificationFlagsCategories.BuyerCommsCode}.${chat.clubhouseId}`}
                                                includePrefix={
                                                    true
                                                }/>
                                        </span>
                                    </Col>
                                    <Col xs="4">
                                        <Button
                                            className="btn btn-primary"
                                            onClick={() =>
                                                props.onChatSelect(chat)
                                            }>
                                            Select
                                        </Button>
                                    </Col>
                                </Row>
                            ))}
                        </div>
                    ) : (
                        <p>No available chats</p>
                    )}
                </div>
            </Rodal>
            {selectedBuyerProfile ? (
                <BuyerProfilePreviewPopup
                    buyerId={selectedBuyerProfile}
                    close={() => setSelectedBuyerProfile(undefined)}
                />
            ) : (
                <></>
            )}
        </div>
    );
};
